<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        sm="6">
        <v-text-field
          v-model="searchCriteria.firstName"
          prepend-icon="mdi-account"
          label="First name"
          dense>
        </v-text-field>
         <v-text-field
          v-model="searchCriteria.lastName"
          prepend-icon="mdi-account-arrow-left"
          label="Last name"
          dense>
        </v-text-field>
        <v-text-field
            v-mask="mobileMask"
            v-model="searchCriteria.mobileNumber"
            label="Mobile number"
            prepend-icon="mdi-cellphone"
            placeholder="04XX-XXX-XXX"
            dense>
        </v-text-field>
        <v-btn
          class="ma-2 primary"
          @click="searchCustomers">
          Search
          <v-icon class="ml-2">mdi-account-search-outline</v-icon>
        </v-btn>
        <v-btn
          class="ma-2 secondary"
          @click="clearSearch">
          Clear
          <v-icon class="ml-2">mdi-eraser</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-data-table
      :headers="headers"
      :items="ADMIN_CUSTOMER_SEARCH_RESULTS"
      dense>
        <template v-slot:item.isActive="{ item }">
          <v-checkbox
            hide-details="auto"
            @change="isActiveChanged(item)"
            v-model="item.isActive"
            dense>
          </v-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon
            dense
            small
            class="mr-2"
            title="Edit customer"
            @click="editCustomer(item)">mdi-pencil
          </v-icon>
        </template>
      </v-data-table>
    </v-row>
    <v-dialog v-model="dialogEdit" max-width="500px">
      <v-card>
        <v-alert
          v-if="SHOW_ALERT"
          prominent
          type="error">
          <v-row align="center">
            <v-col class="grow">{{ ALERT_TEXT }}</v-col>
            <v-col class="shrink">
              <v-btn @click="closeAlert()">Ok</v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card-title>
          Edit Customer
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="customer" v-slot="{ invalid, valid, errors }">
            <v-form v-model="isValid">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-container>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          rules="required"
                          name="FirstName"
                          vid="firstName"
                          v-slot="{ errors }">
                          <v-text-field
                            v-model="editedItem.firstName"
                            :error-messages="errors"
                            maxlength="50"
                            label="First name"
                            append-icon="mdi-card-bulleted-outline"
                            placeholder="Enter first name"
                            dense>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          rules="required"
                          name="LastName"
                          vid="lastname"
                          v-slot="{ errors }">
                          <v-text-field
                            v-model="editedItem.lastName"
                            :error-messages="errors"
                            maxlength="50"
                            label="Last name"
                            placeholder="Enter last name"
                            dense>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          name="MobileNumber"
                          :rules="mobileNumberRules"
                          vid="mobileNumber"
                          v-slot="{ isPhoneInputValid }" slim>
                          <vue-tel-input-vuetify
                            label="Mobile"
                            placeholder="Enter a mobile number"
                            v-model="editedItem.mobileNumber"
                            hint="If outside Australia, choose your country"
                            @input="validateMobile"
                            :error-messages="phoneError"
                            :error="isPhoneInputValid"
                            dense>
                          </vue-tel-input-vuetify>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          name="PhoneNumber"
                          vid="phoneNumber"
                          :rules="phoneNumberRules"
                          v-slot="{ errors }">
                          <v-text-field
                            v-model="editedItem.phoneNumber"
                            :error-messages="errors"
                            maxlength="50"
                            label="Phone"
                            placeholder="Enter phone number"
                            dense>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          :rules="emailAddressRules"
                          name="EmailAddress"
                          vid="emailAddress"
                          v-slot="{ errors }">
                          <v-text-field
                            v-model="editedItem.emailAddress"
                            :error-messages="errors"
                            maxlength="50"
                            label="Email"
                            append-icon="mdi-email"
                            type="email"
                            placeholder="Enter email address"
                            dense>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <vuetify-google-autocomplete
                          ref="addressAutocomplete"
                          id="map"
                          name="map"
                          label="Address"
                          append-icon="mdi-magnify"
                          placeholder="Search for address"
                          v-on:placechanged="getAddressData"
                          v-model="editedItem.address.formattedAddress"
                          :country="limitToCountries"
                          required>
                          <template v-slot:append>
                            <v-btn icon color="primary" v-on:click="clearAddress">
                              <v-icon>mdi-eraser</v-icon>
                            </v-btn>
                          </template>
                        </vuetify-google-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          rules="required"
                          name="CommunicationType"
                          vid="communicationType"
                          v-slot="{ errors }">
                          <v-select
                            :error-messages="errors"
                            :items="communicationTypes"
                            item-text="text"
                            item-value="value"
                            label="Communication type"
                            outlined
                            dense
                            v-model="editedItem.communicationTypeId">
                          </v-select>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          rules="required|min_value:0"
                          name="Discount $"
                          vid="discountDollars"
                          v-slot="{ errors }">
                          <v-currency-field
                            :error-messages="errors"
                            label="Discount $"
                            v-model="editedItem.discountDollars"
                            prefix="$"
                            type="number"
                            money="money"
                            maxlength="5"
                            dense>
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <ValidationProvider
                          rules="required|min_value:0|max_value:100"
                          name="Discount %"
                          vid="discountPercent"
                          v-slot="{ errors }">
                          <v-currency-field
                            :error-messages="errors"
                            label="Discount %"
                            v-model="editedItem.discountPercent"
                            suffix="%"
                            type="number"
                            money="money"
                            maxlength="5"
                            dense>
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-checkbox
                          label="Is Active"
                          v-model="editedItem.isActive"
                          dense />
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
              </v-menu>
            </v-form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';
/* eslint-disable camelcase */
import {
  max_value,
  min_value,
  regex,
  required,
  email,
} from 'vee-validate/dist/rules';
/* eslint-enable camelcase */
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');

extend('email', email);
extend('regex', regex);
extend('required', required);
extend('min_value', min_value);
extend('max_value', max_value);

export default {
  name: 'Customers',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    mask,
  },
  data: () => ({
    communicationTypes: [
      { value: 1, text: 'Sms' },
      { value: 2, text: 'Phone' },
      { value: 3, text: 'Email' },
      { value: 4, text: 'Both' },
    ],
    limitToCountries: ['AU'],
    editedItem: {},
    dialogEdit: false,
    menu1: false,
    isValid: false,
    isPhoneInputValid: false,
    mobileMask: '####-###-###',
    phoneError: null,
    searchCriteria: {
      firstName: null,
      lastName: null,
      mobileNumber: null,
    },
    headers: [
      { text: 'Actions', value: 'actions', sortable: false },
      {
        text: 'First name',
        align: 'start',
        filterable: false,
        value: 'firstName',
      },
      { text: 'LastName', value: 'lastName' },
      { text: 'Address', value: 'address.formattedAddress' },
      { text: 'Suburb', value: 'suburb' },
      { text: 'Mobile #', value: 'mobileNumber' },
      { text: 'Is Active', value: 'isActive' },
    ],
  }),
  beforeRouteLeave(to, from, next) {
    this.$store.commit(storeConstants.RESET_ADMIN_CUSTOMERS);
    this.searchCriteria = {};
    next();
  },
  methods: {
    ...mapActions([
      storeConstants.SET_ALERT_DETAILS,
      storeConstants.SEARCH_ADMIN_CUSTOMERS,
      storeConstants.SAVE_CUSTOMER_ADMIN]),
    clearAddress() {
      this.$refs.addressAutocomplete.clear();
    },
    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData(addressData, placeResultData) {
      // check if subpremise (unit) is part of the address.
      if (placeResultData.address_components) {
        placeResultData.address_components.forEach((place) => {
          if (place.types) {
            place.types.forEach((type) => {
              if (type === 'subpremise') {
                this.subPremise = place.long_name;
              }
            });
          }
        });
      }

      this.editedItem.address.streetNumber = addressData.street_number;
      this.editedItem.address.street = addressData.route;
      this.editedItem.address.suburb = addressData.locality;
      this.editedItem.address.state = addressData.administrative_area_level_1;
      this.editedItem.address.postCode = addressData.postal_code;
      this.editedItem.address.country = addressData.country;
      this.editedItem.address.latitude = addressData.latitude;
      this.editedItem.address.longitude = addressData.longitude;
      this.editedItem.address.formattedAddress = placeResultData.formatted_address;
      this.editedItem.address.place = placeResultData;
    },
    editCustomer(customer) {
      this.editedItem = Object.assign({}, customer);
      this.dialogEdit = true;
    },
    validateMobile(formattedNumber, { number, valid }) {
      this.isPhoneInputValid = valid;

      if (!valid) {
        this.phoneError = 'Please enter a valid mobile number';
        return;
      }

      this.phoneError = null;
      this.editedItem.mobileNumber = number.international;
    },
    searchCustomers() {
      this.$store.commit('SET_LOADING_TEXT', 'Searching customers...');
      this.$store.commit('SET_LOADING', true);

      this.SEARCH_ADMIN_CUSTOMERS(this.searchCriteria)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.$store.commit('SET_LOADING', false);
        })
        .catch(() => {
          this.$store.commit('SET_LOADING', false);
        });
    },
    clearSearch() {
      this.$store.commit(storeConstants.SET_ADMIN_CUSTOMERS, []);
      this.searchCriteria = {};
    },
    close() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
      this.dialogEdit = false;
      this.searchCustomers();
    },
    closeAlert() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
    },
    save() {
      this.SET_ALERT_DETAILS({ alertText: undefined, showAlert: false });
      this.$refs.customer.validate().then((success) => {
        this.isValid = success;
        if (this.isValid) {
          this.SAVE_CUSTOMER_ADMIN(this.editedItem)
            .then(() => {
              this.$store.commit('SET_LOADING', false);
              this.searchCustomers();
              this.dialogEdit = false;
            })
            .catch((error) => {
              if (error.response.data.errors) {
                const keyNames = Object.keys(error.response.data.errors);
                const errors = keyNames.map(a => error.response.data.errors[a].join());
                this.SET_ALERT_DETAILS({ alertText: errors.join(), showAlert: true });
              } else {
                this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
              }

              this.$store.commit('SET_LOADING', false);
            });
        }
      });
    },
    isActiveChanged(item) {
      this.SAVE_CUSTOMER_ADMIN(item)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
          this.$store.commit('SET_LOADING', false);
        })
        .catch(() => {
          this.$store.commit('SET_LOADING', false);
        });
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.ADMIN_CUSTOMER_SEARCH_RESULTS,
      storeConstants.SHOW_ALERT,
      storeConstants.ALERT_TEXT]),
    mobileNumberRules() {
      let rules = null;
      if (this.editedItem.communicationTypeId === 1 || this.editedItem.communicationTypeId === 4) {
        rules = { required: true };
      }
      return rules;
    },
    phoneNumberRules() {
      let rules = null;
      if (this.editedItem.communicationTypeId === 2) {
        rules = { required: true };
      }
      return rules;
    },
    emailAddressRules() {
      let rules = null;
      if (this.editedItem.communicationTypeId === 3 || this.editedItem.communicationTypeId === 4) {
        rules = { required: true, email: true };
      }
      return rules;
    },
  },
};
</script>
<style scoped>
  .v-input--selection-controls.v-input--checkbox {
    margin-top: 0;
    padding-top: 0;
  }
</style>
